import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const reasons = () => ({
  reason_no_longer_need_it: I18n.t('publisher.account_settings.profile.delete_account.reason_no_longer_need_it'),
  reason_found_a_better_tool: I18n.t('publisher.account_settings.profile.delete_account.reason_found_a_better_tool'),
  reason_product_doesnt_work: I18n.t('publisher.account_settings.profile.delete_account.reason_product_doesnt_work'),
  reason_pricing_plan_change: I18n.t('publisher.account_settings.profile.delete_account.reason_pricing_plan_change'),
  reason_too_expensive: I18n.t('publisher.account_settings.profile.delete_account.reason_too_expensive'),
  reason_other: I18n.t('publisher.account_settings.profile.delete_account.reason_other')
});
export const formattedReasonOptions = () => Object.entries(reasons()).map(([id, name]) => ({
  id,
  name
}));
export const listItems = (translations, htmlParseContext = {}) => translations.map(line => {
  const key = line.split()[0];
  return <li key={key}>{HtmlParser(line, htmlParseContext)}</li>;
});
const formRowCss = "f1vueh19";
export const FormRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formRowCss, props.className)} />;
});
const formBlockCss = "fbp8x34";
export const FormBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formBlockCss, props.className)} />;
});
const labelCss = "l1ko1oxh";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const labelTextCss = "latjky8";
export const LabelText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(labelTextCss, props.className)} />;
});
const rowCss = "r1x64ki";
export const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const textCss = "tqrid1x";
export const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textCss, props.className)} />;
});
const warningCss = "wmjgqln";
export const Warning = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(warningCss, props.className)} />;
});

require("./shared.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared.js");